export const SET_PENDING_CASE_IDS: string = "set_pending_case_ids";
export const SET_PENDING: string = "set_pending";
export const SET_UPLOAD_START: string = "set_upload_start";
export const SET_UPLOAD_IN_PROGRESS: string = "set_upload_in_progress";
export const SET_UPLOAD_COMPLETE: string = "set_upload_complete";
export const SET_NEW_CASE_CREATED: string = "set_new_case_created";
export const SET_CASE_DETAILS_UPDATED: string = "set_case_details_updated";
export const SET_CASE_DELETED: string = "set_case_deleted";
export const MERGE_CASE_CHAT_UNREAD: string = "merge_case_chat_unread";
export const BUMP_CASE_CHAT_UNREAD: string = "bump_case_chat_unread";
export const CLEAR_CASE_CHAT_UNREAD: string = "clear_case_chat_unread";
export const SET_CASE_CHAT_DRAWER_CASE_ID: string = "set_case_chat_drawer_case_id";
